var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-card',{staticClass:"select-sublocation-card"},[_vm._v(" "+_vm._s(_vm.$t('sublocation.selectAlert'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }